import { useDesignMaxTheme } from "@/packages";
import { type SpecialPreviewInfoResponse } from "@/shared/server";
import { Box, chakra } from "@chakra-ui/react";
import { motion } from "framer-motion";
import { SpecialInfo } from "./components";

export const SpecialDetail = ({
    inView,
    data,
    currentIdx,
    nextSlide,
    prevSlide,
}: {
    prevSlide: () => void;
    nextSlide: () => void;
    currentIdx: number;
    inView: boolean;
    data: SpecialPreviewInfoResponse;
}) => {
    const { MEDIAS } = useDesignMaxTheme();
    const { isMobile, isLaptop, isDesktop } = MEDIAS();
    const contentPCHeight = isLaptop ? "528PX" : "792px";
    const contentPCPaddingRight = isLaptop ? "88px" : "256px";
    const motionContentPCPadding = isLaptop ? "64px 48px" : "80px 80px 80px 24px";

    return (
        <Box
            position="absolute"
            w="100%"
            maxH={isMobile ? "552PX" : "none"}
            h={isMobile ? "100%" : contentPCHeight}
            top="50%"
            left="50%"
            zIndex="1"
            transform="translate(-50%, -50%)"
            paddingRight={isMobile ? "0" : contentPCPaddingRight}
        >
            <MotionSpecialsDetailContainer
                position="relative"
                justifyContent="flex-end"
                display="flex"
                w="100%"
                height="100%"
                padding={isMobile ? "24px" : motionContentPCPadding}
                borderRightRadius="16px"
                background="whiteAlpha.900"
                initial={{ width: "10%" }}
                animate={inView ? { width: "100%", transition: { duration: 0.5 } } : {}}
            >
                <MotionContent
                    maxW={isDesktop ? "1424px" : "1744px"}
                    display="flex"
                    w="100%"
                    h="100%"
                    flexDir="column"
                    paddingLeft={isLaptop ? "0" : "24px"}
                    rowGap={isLaptop ? "16px" : "24px"}
                    initial={{ visibility: "hidden", opacity: 0 }}
                    animate={
                        inView
                            ? {
                                  visibility: "visible",
                                  opacity: 1,
                                  transition: { delay: 0.25, ease: "easeInOut", duration: 0.3 },
                              }
                            : {}
                    }
                >
                    <SpecialInfo data={data} currentIdx={currentIdx} prevSlide={prevSlide} nextSlide={nextSlide} />
                </MotionContent>
            </MotionSpecialsDetailContainer>
        </Box>
    );
};

const MotionSpecialsDetailContainer = chakra(motion.div);
const MotionContent = chakra(motion.div);
